import axios from 'axios';
import { loginUrl } from '../utils/next';

// Django's session auth: the csrftoken cookie goes back as X-CSRFToken on unsafe methods
const client = axios.create({
  baseURL: '/api',
  headers: { Accept: 'application/json' },
  withCredentials: true,
  xsrfCookieName: 'csrftoken',
  xsrfHeaderName: 'X-CSRFToken',
});

// Errors carry the backend's message (DRF's detail, or our views' message). A 401 means the session has ended: back
// to the sign in page, which returns here afterwards
client.interceptors.response.use(
  (response) => response.data,
  (error) => {
    const { response } = error;
    if (response?.status === 401 && window.location.pathname !== '/login') {
      window.location.assign(loginUrl(window.location.pathname + window.location.search));
    }
    const data = response?.data || {};
    const message = data.message || data.detail || (response ? `Request failed (${response.status})` : error.message);
    return Promise.reject(Object.assign(new Error(message), { status: response?.status }));
  },
);

const Api = {
  get: (url, { params } = {}) => client.get(url, { params }),
  post: (url, data) => client.post(url, data),
  patch: (url, data) => client.patch(url, data),
};

export default Api;
